const PORTAL_COLOR_OPTIONS = [
  { value: 'emerald', label: 'Emerald', swatch: 'bg-emerald-500' },
  { value: 'blue', label: 'Blue', swatch: 'bg-blue-500' },
  { value: 'purple', label: 'Purple', swatch: 'bg-purple-500' },
  { value: 'primary', label: 'Primary', swatch: 'bg-primary-500' },
  { value: 'secondary', label: 'Secondary', swatch: 'bg-secondary-500' },
  { value: 'amber', label: 'Amber', swatch: 'bg-amber-500' },
  { value: 'rose', label: 'Rose', swatch: 'bg-rose-500' },
  { value: 'cyan', label: 'Cyan', swatch: 'bg-cyan-500' },
  { value: 'orange', label: 'Orange', swatch: 'bg-orange-500' },
];

const PortalColorPicker = ({ value, onChange }) => (
  <div>
    <label className="text-xs font-semibold uppercase text-gray-500">Color</label>
    <div className="mt-2 flex flex-wrap gap-2">
      {PORTAL_COLOR_OPTIONS.map((color) => (
        <button
          key={color.value}
          type="button"
          title={color.label}
          onClick={() => onChange(color.value)}
          className={`w-8 h-8 rounded-full ${color.swatch} transition-all ${
            value === color.value
              ? 'ring-2 ring-offset-2 ring-gray-900 dark:ring-white scale-110'
              : 'opacity-80 hover:opacity-100 hover:scale-105'
          }`}
        />
      ))}
    </div>
  </div>
);

export default PortalColorPicker;
